// extracted by mini-css-extract-plugin
export default {"root":"OW45fd9i","nft":"HmnTdlh8","image":"H3EA9Tak","name":"_gZbYTeY","expander":"T7bQHi3K"};